<template>
  <div class="flex justify-center items-center h-screen w-screen">
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
}
</script>
